import React, { useEffect, useState } from 'react'
import portFolio from '../api/portfolio.json';
import Aos from 'aos';
import load from 'lodash'

const Portfolio = () => {

    useEffect(()=>{
        Aos.init()
        Aos.refresh()
    },[])

    const [active, setActive] = useState(false);
    const [source, setSource] = useState('');
    const ImgViewModel = (e) => {
        setSource(e.target.currentSrc)
      
            setTimeout(()=>{
                setActive(true);
            },300)
       
    } 
    return (
        <>
            <div className="gallery-section">
                <div className="container">
                    <div className="row">
                        <div className="project-text-column col-lg-12">
                            <div className="text-align-center">
                                <h2 className="section-heading">
                                    Portfolio 📸
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">

                        {load.shuffle(portFolio).map((cur, i, arr) => {
                            return <div key={i} 
                          data-aos={i%2==0?"fade-down":"fade-left"}
                            className="col-lg-3">
                                <img src={cur.img} onClick={ImgViewModel} alt={cur.alt} className="gallery-image img-fluid img-thumbnail" />
                            </div>
                        })}


                        <div  onClick={() => setActive((false))} className={`  ${active ? "fade modal-backdrop show" : ""} `}></div>
                        <div
                            role="dialog"
                            aria-modal="true"
                            className="modal fade  show"
                            tabIndex={-1}
                            onClick={() => setActive((false))}
                            style={{ display: `${active ? "block" : "none"}` }}
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="p-0 modal-body">
                                        <img
                                            src={source}
                                            alt="nidekUafs"
                                            loading="lazy"
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Portfolio